import Component from '../colorz/Component';

import emitter from '../colorz/utils/Emitter';

module.exports = class VideosPatchwork extends Component {
  onInit( el, args) {
    // Initializations
    this.onPopinClose = this.onPopinClose.bind( this );
    this.onPopinOpen  = this.onPopinOpen.bind( this );

    this.el = el;
    this.wrapper = this.el.querySelector('.popin__wrapper');
    this.timeout = null;
  }

  onReady() {
    emitter.on('popin:close', this.onPopinClose);
    emitter.on('popin:open', this.onPopinOpen);
  }

  onPopinOpen() {
    clearTimeout( this.timeout );

    requestAnimationFrame( () => {
      this.wrapper.classList.add('is-fade-in');
    });
  }

  onPopinClose() {
    this.wrapper.classList.remove('is-fade-in');

    this.timeout = setTimeout( () => {
      this.wrapper.style.display = 'none';
    }, 300);
  }
}